<template>
  <div class="container-fluid">
    <loading
      :active.sync="isLoading"
      :enforce-focus="false"
      loader="dots"
    ></loading>

    <div class="card search-card">
      <div class="card-body">
        <div class="form-row">
          <div class="col-sm-3 col-md-3">
            <div class="form-group">
              <label for="">面談日期</label>
              <el-date-picker
                style="width: 100%"
                :picker-options="pickerOptions"
                v-model="search.InvitationTime"
                value-format="yyyy-MM-dd"
                type="daterange"
                placeholder="yyyy-mm-dd"
                :disabled="activeName !== 'third'"
              >
              </el-date-picker>
            </div>
          </div>
          <div class="col-sm-3 col-md-3">
            <div class="form-group">
              <label for="">時段</label>
              <el-select
                style="display: block"
                v-model="search.TimePeriod"
                placeholder="請選擇"
                filterable
              >
                <el-option
                  :key="option.Value"
                  :label="option.Text"
                  v-for="option in timePeriodOptions"
                  :value="option.Value"
                >
                </el-option>
              </el-select>
            </div>
          </div>

          <div class="col-sm-3 col-md-3">
            <div class="form-group">
              <label for="">應徵職務</label>
              <input
                type="text"
                class="form-control"
                placeholder="請輸入關鍵字"
                v-model.trim="search.ManpowerDemandName"
              />
            </div>
          </div>
          <div class="col-sm-3 col-md-3">
            <div class="form-group">
              <label for="">招募窗口</label>
              <input
                type="text"
                class="form-control"
                placeholder="請輸入關鍵字"
                v-model.trim="search.ContactPersonKeyword"
              />
            </div>
          </div>
          <div class="col-sm-3 col-md-3">
            <div class="form-group">
              <label for="">姓名</label>
              <input
                type="text"
                class="form-control"
                placeholder="請輸入關鍵字"
                v-model.trim="search.NameKeyword"
              />
            </div>
          </div>
          <div class="col-sm-3 col-md-3">
            <div class="form-group">
              <label for="">身分證關鍵字</label>
              <input
                type="text"
                class="form-control"
                placeholder="請輸入關鍵字"
                v-model.trim="search.IdNoKeyword"
              />
            </div>
          </div>

          <div class="col-sm-3 col-md-3">
            <button
              type="button"
              class="btn btn-primary"
              style="margin-top: 30px; margin-right: 5px"
              @click="getCheckIn"
            >
              {{ i18n("BUTTON.SEARCH") }}
            </button>
            <button
              type="button"
              class="btn btn-secondary"
              style="margin-top: 30px; margin-right: 5px"
              @click="
                search = {
                  InvitationTime: search.InvitationTime,
                  TimePeriod: 0,
                }
              "
            >
              清除
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="text-right">更新時間 : {{ reloadTime }}</div>
    <div class="fixed-list-item">
      <eva-icon fill="#000" name="refresh-outline" @click="reload" />
    </div>

    <el-tabs v-model="activeName" @tab-click="changeTab()">
      <el-tab-pane label="當天預約到廠" name="first"> </el-tab-pane>
      <el-tab-pane label="臨時到廠" name="second">
        <div class="function-card">
          <span style="cursor: pointer" @click="qrCodeDialogVisible = true">
            <qrcode-vue :value="QRCode" size="100" />
          </span>

          <el-button type="primary" size="small" @click="openTemporaryModal()"
            >新增臨時到廠</el-button
          >
        </div>
      </el-tab-pane>

      <el-tab-pane label="後續預約到廠" name="third">
        <!-- 卡片顯示樣式 -->
      </el-tab-pane>
    </el-tabs>

    <div class="card-list">
      <div
        class="p-card"
        :class="{
          darken: person.endTime === null,
          'gray-card': person.Status === 1 || person.Status === 2,
        }"
        v-for="(person, index) in personList"
        :key="index"
      >
        <div class="person-info">
          <div class="info">
            <div
              class="name"
              :class="{
                female: person.Sex === '女',
                male: person.Sex === '男',
              }"
              @click="showDetailModal(person)"
            >
              {{ person.Name }}
            </div>
            <div class="id">{{ person.MobilePhone }}</div>

            <div class="check-label" v-if="person.ArrangeTempType === 2">
              <input
                type="checkbox"
                :value="person.ArrangeTempGuid"
                v-model="choosePersonList"
              />
            </div>

            <el-tooltip
              class="item"
              effect="dark"
              :content="person.ManpowerDemandName"
              placement="bottom"
            >
              <div class="job">
                <eva-icon width="25" fill="#000" name="briefcase-outline" />

                <template v-if="person.ArrangeTempType === 1">
                  {{ person.ManpowerDemandName }}
                </template>
                <template v-else> 尚未轉入職缺 </template>
              </div>
            </el-tooltip>

            <div class="job" width="25" v-if="person.InvitationTime">
              <eva-icon fill="#000" name="calendar-outline" />{{
                person.InvitationTime | moment
              }}
            </div>
          </div>
        </div>
        <div class="job-info">
          <span>
            <div class="svg-wrap">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                <path
                  d="M502.6 198.6l-61.25-61.25C435.4 131.4 427.3 128 418.8 128H256C220.7 128 191.1 156.7 192 192l.0065 255.1C192 483.3 220.7 512 256 512h192c35.2 0 64-28.8 64-64l.0098-226.7C512 212.8 508.6 204.6 502.6 198.6zM464 448c0 8.836-7.164 16-16 16h-192c-8.838 0-16-7.164-16-16L240 192.1c0-8.836 7.164-16 16-16h128L384 224c0 17.67 14.33 32 32 32h48.01V448zM317.7 96C310.6 68.45 285.8 48 256 48H215.2C211.3 20.93 188.1 0 160 0C131.9 0 108.7 20.93 104.8 48H64c-35.35 0-64 28.65-64 64V384c0 35.34 28.65 64 64 64h96v-48H64c-8.836 0-16-7.164-16-16V112C48 103.2 55.18 96 64 96h16v16c0 17.67 14.33 32 32 32h61.35C190 115.4 220.6 96 256 96H317.7zM160 72c-8.822 0-16-7.176-16-16s7.178-16 16-16s16 7.176 16 16S168.8 72 160 72z"
                />
              </svg>
            </div>

            <el-select
              @change="saveFlow($event, person.ArrangeGuid)"
              style="width: 100%"
              v-model="person.BaseFlowGuid"
              placeholder="請選擇流程"
              :disabled="
                (person.Status !== 3 && person.Status !== 4) ||
                person.ArrangeTempType !== 1
              "
              filterable
            >
              <el-option
                v-for="item in flowOptions"
                :key="item.Value"
                :label="item.Text"
                :value="item.Value"
                :disabled="!item.IsEnabled"
              >
              </el-option>
            </el-select>
          </span>

          <span>
            <div class="svg-wrap">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                <path
                  d="M272 304h-96C78.8 304 0 382.8 0 480c0 17.67 14.33 32 32 32h384c17.67 0 32-14.33 32-32C448 382.8 369.2 304 272 304zM48.99 464C56.89 400.9 110.8 352 176 352h96c65.16 0 119.1 48.95 127 112H48.99zM224 256c70.69 0 128-57.31 128-128c0-70.69-57.31-128-128-128S96 57.31 96 128C96 198.7 153.3 256 224 256zM224 48c44.11 0 80 35.89 80 80c0 44.11-35.89 80-80 80S144 172.1 144 128C144 83.89 179.9 48 224 48z"
                />
              </svg>
            </div>

            <el-select
              @change="saveContact($event, person.ArrangeGuid)"
              style="width: 100%"
              filterable
              v-model="person.ContactPersonGuid"
              placeholder="請選擇窗口"
              :disabled="person.ArrangeTempType !== 1"
            >
              <el-option
                v-for="item in contactOptions"
                :key="item.Value"
                :label="item.Text"
                :value="item.Value"
              >
              </el-option>
            </el-select>
          </span>

          <span>
            <div class="svg-wrap">H</div>
            <el-select
              @change="setHrSupervisor($event, person.ArrangeGuid)"
              style="width: 100%"
              filterable
              v-model="person.HrSupervisorId"
              placeholder="請選擇HR主管"
              :disabled="person.Status !== 3 || person.ArrangeTempType !== 1"
            >
              <el-option
                v-for="item in contactOptions"
                :key="item.Value"
                :label="item.Text"
                :value="item.Value"
              >
              </el-option>
            </el-select>
          </span>

          <span>
            <div class="svg-wrap">M</div>

            <el-select
              @change="setManagerSupervisor($event, person.ArrangeGuid)"
              style="width: 100%"
              filterable
              v-model="person.ManagerSupervisorId"
              placeholder="請選擇面試主管"
              :disabled="person.Status !== 3 || person.ArrangeTempType !== 1"
            >
              <el-option
                v-for="item in contactOptions"
                :key="item.Value"
                :label="item.Text"
                :value="item.Value"
              >
              </el-option>
            </el-select>
          </span>

          <span>
            <div class="svg-wrap">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                <path
                  d="M232 120C232 106.7 242.7 96 256 96C269.3 96 280 106.7 280 120V243.2L365.3 300C376.3 307.4 379.3 322.3 371.1 333.3C364.6 344.3 349.7 347.3 338.7 339.1L242.7 275.1C236 271.5 232 264 232 255.1L232 120zM256 0C397.4 0 512 114.6 512 256C512 397.4 397.4 512 256 512C114.6 512 0 397.4 0 256C0 114.6 114.6 0 256 0zM48 256C48 370.9 141.1 464 256 464C370.9 464 464 370.9 464 256C464 141.1 370.9 48 256 48C141.1 48 48 141.1 48 256z"
                />
              </svg>
            </div>

            <div class="info-time">
              {{ person.InvitationTime | momentTime }}/
              <template v-if="person.CheckInTime !== null">{{
                person.CheckInTime | momentTime
              }}</template>
            </div>
          </span>

          <div class="button-wrap text-center">
            <template v-if="person.Status === 3">
              <template v-if="person.ArrangeTempType === 1">
                <button
                  v-if="!person.CheckInTime"
                  type="button"
                  class="btn btn-danger btn-sm mr-1"
                  @click="openCancelModal(person)"
                >
                  取消
                </button>
                <button
                  type="button"
                  class="btn btn-info btn-sm mr-1"
                  @click="openReArrangeModal(person)"
                >
                  改期
                </button>
                <button
                  v-if="activeName !== 'third'"
                  type="button"
                  class="btn btn-primary btn-sm"
                  @click="checkIn(person)"
                >
                  報到
                </button>
              </template>

              <el-alert
                v-if="person.ArrangeTempType === 2"
                :closable="false"
                center
                title="尚未轉入職缺"
                type="info"
              >
              </el-alert>

              <el-alert
                v-if="person.ArrangeTempType === 3"
                :closable="false"
                center
                title="沒有對應履歷"
                type="info"
              >
              </el-alert>
            </template>

            <el-alert
              v-if="person.Status === 6"
              :closable="false"
              center
              title="已結案"
              type="success"
            >
            </el-alert>

            <el-alert
              v-if="person.Status === 4 || person.Status === 5"
              :closable="false"
              center
              title="已報到"
              type="success"
            >
            </el-alert>

            <el-alert
              v-if="person.Status === 1"
              :closable="false"
              center
              type="info"
            >
              已改期-{{ person.ReArrangeDate | momentDateTime }}
            </el-alert>

            <el-alert
              v-if="person.Status === 2"
              :closable="false"
              center
              title="已取消"
              type="error"
            >
            </el-alert>
          </div>
        </div>
      </div>
    </div>

    <div v-if="personList.length === 0">暫無資料</div>

    <!-- 功能列 -->
    <div :class="{ showing: choosePersonList.length > 0 }" class="select-count">
      <img src="@/assets/img/select_count.png" alt="" />

      <div class="select-count-inner">
        已選擇{{ choosePersonList.length }}位
        <a
          class="edit-btn"
          href="javascript:void(0)"
          @click.prevent="openMatchJobModal"
        >
          <eva-icon name="share-outline" fill="#FFF"></eva-icon>
          <span>轉入職缺</span>
        </a>
        <a class="clear-btn" @click.prevent="clearSelect">清除</a>
      </div>
    </div>

    <!-- 轉入職缺 Modal -->
    <div
      id="matchJobModal"
      class="modal fade"
      tabindex="-1"
      data-backdrop="static"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <ValidationObserver v-slot="{ handleSubmit }">
            <form @submit.prevent="handleSubmit(matchJobManagement)">
              <div class="modal-header">
                <span>轉入職缺</span>
              </div>
              <div class="modal-body" style="height: 500px">
                <label for=""><span class="mark">*</span>選擇職缺：</label>
                <ValidationProvider
                  ref="matchDemandId"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <el-select
                    v-model="transformModal.ManpowerDemandNo"
                    style="width: 100%"
                    filterable
                    clearable
                    placeholder="請選擇"
                  >
                    <el-option
                      v-for="item in openingList"
                      :key="item.ManpowerDemandNo"
                      :label="
                        item.ManpowerDemandNo + '-' + item.ManpowerDemandName
                      "
                      :value="item.ManpowerDemandNo"
                    >
                    </el-option>
                  </el-select>
                  <p v-if="errors[0]" class="text-danger">
                    {{ errors[0] }}
                  </p>
                </ValidationProvider>

                <label for="">面談流程</label>
                <el-select
                  filterable
                  clearable
                  style="width: 100%"
                  v-model="transformModal.BaseFlowGuid"
                  placeholder="請選擇流程"
                >
                  <el-option
                    v-for="item in flowOptions"
                    :key="item.Value"
                    :label="item.Text"
                    :value="item.Value"
                  >
                  </el-option>
                </el-select>

                <label for="">招募窗口</label>
                <el-select
                  style="width: 100%"
                  filterable
                  clearable
                  v-model="transformModal.ContactPersonGuid"
                  placeholder="請選擇"
                >
                  <el-option
                    v-for="item in contactOptions"
                    :key="item.Value"
                    :label="item.Text"
                    :value="item.Value"
                  >
                  </el-option>
                </el-select>

                <label for=""><span class="mark">*</span>HR主管</label>
                <ValidationProvider
                  ref="HrSupervisorGuid"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <el-select
                    style="width: 100%"
                    filterable
                    clearable
                    v-model="transformModal.HrSupervisorGuid"
                    placeholder="請選擇"
                  >
                    <el-option
                      v-for="item in contactOptions"
                      :key="item.Value"
                      :label="item.Text"
                      :value="item.Value"
                    >
                    </el-option>
                  </el-select>
                  <p v-if="errors[0]" class="text-danger">
                    {{ errors[0] }}
                  </p>
                </ValidationProvider>

                <label for="">面試主管</label>
                <el-select
                  style="width: 100%"
                  filterable
                  clearable
                  v-model="transformModal.ManagerSupervisorGuid"
                  placeholder="請選擇"
                >
                  <el-option
                    v-for="item in contactOptions"
                    :key="item.Value"
                    :label="item.Text"
                    :value="item.Value"
                  >
                  </el-option>
                </el-select>
              </div>
              <div class="modal-footer">
                <button
                  type="button"
                  class="btn btn-secondary"
                  data-dismiss="modal"
                >
                  取消
                </button>
                <button
                  type="button"
                  class="btn btn-success"
                  @click="handleSubmit(matchJobManagement)"
                >
                  確定
                </button>
              </div>
            </form>
          </ValidationObserver>
        </div>
      </div>
    </div>

    <!-- 取消 Modal -->
    <div
      class="modal fade"
      id="cancelModal"
      tabindex="-1"
      data-backdrop="static"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">取消</h5>
          </div>
          <div class="modal-body">
            <div class="p-card">
              <div class="person-info">
                <div class="info">
                  <div class="name">{{ currentPerson.Name }}</div>
                  <div class="id">{{ currentPerson.MobilePhone }}</div>
                  <div class="job">{{ currentPerson.ManpowerDemandName }}</div>
                </div>
              </div>
              <div class="job-info">
                <span>
                  <div class="svg-wrap">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 512 512"
                    >
                      <path
                        d="M497.9 142.1l-46.1 46.1c-4.7 4.7-12.3 4.7-17 0l-111-111c-4.7-4.7-4.7-12.3 0-17l46.1-46.1c18.7-18.7 49.1-18.7 67.9 0l60.1 60.1c18.8 18.7 18.8 49.1 0 67.9zM284.2 99.8L21.6 362.4.4 483.9c-2.9 16.4 11.4 30.6 27.8 27.8l121.5-21.3 262.6-262.6c4.7-4.7 4.7-12.3 0-17l-111-111c-4.8-4.7-12.4-4.7-17.1 0zM124.1 339.9c-5.5-5.5-5.5-14.3 0-19.8l154-154c5.5-5.5 14.3-5.5 19.8 0s5.5 14.3 0 19.8l-154 154c-5.5 5.5-14.3 5.5-19.8 0zM88 424h48v36.3l-64.5 11.3-31.1-31.1L51.7 376H88v48z"
                      />
                    </svg>
                  </div>

                  <el-select
                    v-model="currentPerson.CancelSecondGuid"
                    @change="findParentGuid"
                  >
                    <el-option-group
                      v-for="group in cancelOptions"
                      :key="group.Guid"
                      :label="group.Name"
                    >
                      <el-option
                        v-for="item in group.Children"
                        :key="item.Guid"
                        :label="item.Name"
                        :value="item.Guid"
                      >
                      </el-option>
                    </el-option-group>
                  </el-select>
                </span>

                <span>
                  <div class="svg-wrap">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 512 512"
                    >
                      <path
                        d="M497.9 142.1l-46.1 46.1c-4.7 4.7-12.3 4.7-17 0l-111-111c-4.7-4.7-4.7-12.3 0-17l46.1-46.1c18.7-18.7 49.1-18.7 67.9 0l60.1 60.1c18.8 18.7 18.8 49.1 0 67.9zM284.2 99.8L21.6 362.4.4 483.9c-2.9 16.4 11.4 30.6 27.8 27.8l121.5-21.3 262.6-262.6c4.7-4.7 4.7-12.3 0-17l-111-111c-4.8-4.7-12.4-4.7-17.1 0zM124.1 339.9c-5.5-5.5-5.5-14.3 0-19.8l154-154c5.5-5.5 14.3-5.5 19.8 0s5.5 14.3 0 19.8l-154 154c-5.5 5.5-14.3 5.5-19.8 0zM88 424h48v36.3l-64.5 11.3-31.1-31.1L51.7 376H88v48z"
                      />
                    </svg>
                  </div>

                  <el-input
                    placeholder="請輸入取消原因"
                    v-model="currentPerson.CancelReason"
                  >
                  </el-input>
                </span>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="reset" class="btn btn-secondary" data-dismiss="modal">
              關閉
            </button>
            <button
              type="reset"
              class="btn btn-primary"
              @click="cancelInterview()"
            >
              儲存
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- 改期 Modal -->
    <div
      id="interviewMailModal"
      class="modal fade"
      data-focus="false"
      data-keyboard="false"
      data-backdrop="static"
    >
      <div class="modal-dialog modal-dialog-scrollable">
        <ValidationObserver
          class="modal-content"
          v-slot="{ handleSubmit, reset }"
          ref="currentPersonForm"
        >
          <div class="letter-modal">
            <div class="note-wrap">
              <div class="letter-title">改期邀約</div>

              <template>
                <div class="note-title">可動態套入信件內容，請參考以下參數</div>
                <div class="note-table">
                  <table v-if="mailParameters">
                    <tr
                      v-for="(parameter, index) in mailParameters"
                      :key="index"
                    >
                      <th>{{ parameter.MailParameterName }}</th>
                      <td>
                        <span> {{</span>{{ parameter.MailParameterCode
                        }}<span>}} </span>
                      </td>
                    </tr>
                  </table>
                </div>
              </template>
            </div>
            <form @reset.prevent="reset">
              <div class="modal-content border-0">
                <perfect-scrollbar class="modal-body">
                  <div class="form-group">
                    <label for=""
                      ><span style="color: red">*</span>改期日期：</label
                    >
                    <div style="display: flex">
                      <span
                        style="
                          flex: 1;
                          min-width: 1px;
                          position: relative;
                          margin-right: 5px;
                        "
                      >
                        <ValidationProvider
                          name="改期日期"
                          rules="required"
                          v-slot="{ errors }"
                        >
                          <el-date-picker
                            :picker-options="reArrangeDatePickerOptions"
                            value-format="yyyy-MM-dd"
                            format="yyyy-MM-dd"
                            v-model="currentPerson.ReArrangeDate"
                            type="date"
                            placeholder="選擇日期"
                            style="width: 100%"
                          >
                          </el-date-picker>
                          <span
                            class="text-danger"
                            style="position: absolute; bottom: 0; right: 0"
                          >
                            {{ errors[0] }}
                          </span>
                        </ValidationProvider>
                      </span>

                      <span
                        style="
                          flex: 1;
                          min-width: 1px;
                          position: relative;
                          border-radius: 4px;
                          border: 1px solid #dcdfe6;
                        "
                      >
                        <ValidationProvider
                          name="改期時間"
                          rules="required"
                          v-slot="{ errors }"
                        >
                          <date-picker id="ReArrangeTime" class="w-100"
                          format="HH:mm" value-type="format" type="time"
                          :default-value="new Date().setHours(8, 0, 0, 0)"
                          :minute-step="10" start= '00:00' end:='23:30'
                          placeholder="選擇時間"
                          v-model="currentPerson.ReArrangeTime" />
                          <span
                            class="text-danger"
                            style="position: absolute; bottom: 0; right: 0"
                          >
                            {{ errors[0] }}
                          </span>
                        </ValidationProvider>
                      </span>
                    </div>
                  </div>
                  <div class="form-group">
                    <label for="">改期原因：</label>

                    <el-select
                      v-model="currentPerson.ReArrangeGuid"
                      style="width: 100%"
                    >
                      <el-option
                        v-for="item in reArrangeOptions"
                        :key="item.Guid"
                        :label="item.Name"
                        :value="item.Guid"
                      ></el-option>
                    </el-select>
                  </div>

                  <div class="form-group">
                    <label for="">請輸入改期原因：</label>

                    <el-input
                      placeholder="請輸入改期原因"
                      v-model="currentPerson.ReArrangeReason"
                    >
                    </el-input>
                  </div>

                  <div class="form-group">
                    <label for=""> 單位面試主管：</label>
                    <el-select
                      class="w-100"
                      filterable
                      clearable
                      placeholder="請選擇"
                      v-model="currentPerson.InterviewSupervisor"
                    >
                      <el-option
                        v-for="supervisor in supervisorOptions"
                        :key="supervisor.Guid"
                        :label="supervisor.Name"
                        :value="supervisor.Guid"
                      >
                      </el-option>
                    </el-select>
                  </div>
                  <div class="form-group">
                    <label for="">
                      <span style="color: red">*</span>HR 面試人員：
                    </label>
                    <ValidationProvider
                      rules="required"
                      name="HR面試人員"
                      class="w-100"
                      v-slot="{ errors }"
                    >
                      <el-select
                        class="w-100"
                        filterable
                        placeholder="請選擇"
                        v-model="currentPerson.InterviewHR"
                      >
                        <el-option
                          v-for="supervisor in supervisorOptions"
                          :key="supervisor.Guid"
                          :label="supervisor.Name"
                          :value="supervisor.Guid"
                        >
                        </el-option>
                      </el-select>
                      <p class="text-danger" style="font-size: 13px">
                        {{ errors[0] }}
                      </p>
                    </ValidationProvider>
                  </div>

                  <div class="form-group">
                    <ValidationProvider
                      rules="required"
                      name="面談地點"
                      v-slot="{ errors }"
                    >
                      <label for="">
                        <span style="color: red">*</span>面談地點：
                      </label>
                      <el-select
                        class="w-100"
                        filterable
                        placeholder="請選擇"
                        v-model="currentPerson.InterviewPlace"
                      >
                        <el-option
                          v-for="place in interviewPlaceOptions"
                          :key="place.Guid"
                          :label="place.Name"
                          :value="place.Name"
                        >
                        </el-option>
                      </el-select>
                      <p class="text-danger" style="font-size: 13px">
                        {{ errors[0] }}
                      </p>
                    </ValidationProvider>

                    <template>
                      <div class="form-group">
                        <label for="">面談說明：</label>
                        <textarea
                          class="form-control w-100"
                          rows="3"
                          maxlength="10000"
                          v-model="currentPerson.Remark"
                        />
                      </div>

                      <div class="form-group">
                        <label for="">附件：</label>
                        <el-upload
                          class="upload-demo"
                          action
                          :auto-upload="false"
                          :show-file-list="false"
                          :on-change="uploadFile"
                        >
                          <el-button size="small" type="primary">
                            點擊上傳
                          </el-button>
                        </el-upload>
                        <template v-if="uploadFileList">
                          <div
                            v-for="file in uploadFileList"
                            :key="file.FileGuid"
                          >
                            <p
                              style="margin-top: 20px; cursor: pointer"
                              @click="
                                $common.downloadFile({
                                  fileGuid: file.FileGuid,
                                  fileType: file.FileContentType,
                                })
                              "
                            >
                              <eva-icon fill="#000" name="attach-outline" />
                              <span
                                style="
                                  margin-left: 15px;
                                  vertical-align: text-top;
                                "
                              >
                                {{ file.FileName }}
                              </span>
                              <span
                                style="
                                  display: inline-block;
                                  position: absolute;
                                  right: 25px;
                                "
                                @click.stop="
                                  removeFile({
                                    fileGuid: file.FileGuid,
                                    fileGroupGuid: file.FileGroupGuid,
                                  })
                                "
                              >
                                <eva-icon fill="#000" name="trash-2-outline" />
                              </span>
                            </p>
                          </div>
                        </template>
                      </div>

                      <div class="form-group">
                        <label for=""> 信件範本： </label>
                        <el-select
                          class="w-100"
                          filterable
                          clearable
                          placeholder="請選擇"
                          @change="getMailTemplateDetail"
                          v-model="selectedTemplateGuid"
                        >
                          <el-option
                            v-for="template in mailTemplates"
                            :key="template.MailTemplateGuid"
                            :label="template.MailTemplateName"
                            :value="template.MailTemplateGuid"
                          >
                          </el-option>
                        </el-select>
                      </div>

                      <div class="form-group">
                        <ValidationProvider
                          rules="required"
                          name="信件主旨"
                          class="w-100"
                          v-slot="{ errors }"
                        >
                          <label for="">
                            <span class="mark">*</span>信件主旨：
                          </label>
                          <input
                            placeholder="請輸入信件主旨或選擇範本"
                            class="form-control w-100"
                            v-model="currentPerson.MailSubject"
                          />
                          <p class="text-danger" style="font-size: 13px">
                            {{ errors[0] }}
                          </p>
                        </ValidationProvider>
                      </div>

                      <div class="form-group">
                        <ValidationProvider
                          rules="required"
                          name="信件內容"
                          class="w-100"
                          v-slot="{ errors }"
                        >
                          <label for="">
                            <span class="mark">*</span>信件內容：
                          </label>
                          <VueEditor
                            style="background: rgb(255, 255, 255)"
                            v-model="currentPerson.MailTemplateBody"
                          />
                          <p class="text-danger" style="font-size: 13px">
                            {{ errors[0] }}
                          </p>
                        </ValidationProvider>
                      </div>
                    </template>
                  </div>
                </perfect-scrollbar>

                <div class="modal-footer">
                  <button
                    type="reset"
                    class="btn btn-secondary"
                    data-dismiss="modal"
                  >
                    取消
                  </button>
                  <button
                    type="button"
                    class="btn btn-success"
                    @click.prevent="handleSubmit(reArrange)"
                  >
                    寄出
                  </button>
                </div>
              </div>
            </form>
          </div>
        </ValidationObserver>
      </div>
    </div>

    <!-- 臨時到廠 Modal -->
    <div
      class="modal fade"
      id="temporaryModal"
      tabindex="-1"
      data-backdrop="static"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">新增臨時到廠</h5>
          </div>
          <div class="modal-body">
            <el-form
              label-position="top"
              :model="temporaryForm"
              ref="temporaryForm"
            >
              <el-form-item
                label="姓名"
                prop="Name"
                :rules="[{ required: true, message: '必填', trigger: 'blur' }]"
              >
                <el-input v-model="temporaryForm.Name"></el-input>
              </el-form-item>
              <el-form-item
                label="身分證字號/護照號碼"
                prop="IdNo"
                :rules="[{ required: true, message: '必填', trigger: 'blur' }]"
              >
                <el-input v-model="temporaryForm.IdNo"></el-input>
              </el-form-item>
            </el-form>
          </div>
          <div class="modal-footer">
            <button type="reset" class="btn btn-secondary" data-dismiss="modal">
              關閉
            </button>
            <button
              type="reset"
              class="btn btn-primary"
              @click="addArrangeTemporary()"
            >
              儲存
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- 各資訊總覽 -->
    <transition
      name="custom-classes-transition"
      enter-active-class="animated bounceInLeft"
      leave-active-class="animated bounceOutRight"
    >
      <div class="detail-modal" v-if="isShowDetail">
        <div class="detail-modal-inner">
          <div class="menu">
            <template v-if="resumeDetail.ArrangeGuid === null">
              <a @click.prevent="resumeDetail.ResumeType = 'IDL'">
                <span>
                  <eva-icon name="person-outline" fill="#FFF" />
                  IDL 履歷
                </span>
              </a>
              <a @click.prevent="resumeDetail.ResumeType = 'DL'">
                <span>
                  <eva-icon name="person-outline" fill="#FFF" />
                  DL 履歷
                </span>
              </a>
            </template>

            <a v-else>
              <span>
                <eva-icon name="person-outline" fill="#FFF"></eva-icon>
                履歷
              </span>
            </a>

            <div
              class="close-show-detail"
              @click.prevent="isShowDetail = !isShowDetail"
            >
              <eva-icon
                name="close-circle"
                fill="#FFF"
                width="50"
                height="50"
              ></eva-icon>
            </div>
          </div>
          <div class="page-wrap">
            <transition
              name="custom-classes-transition"
              enter-active-class="animated flipInY"
            >
              <perfect-scrollbar class="page">
                <section class="page-inner">
                  <div class="title">
                    <div class="item text-center">履歷</div>
                    <div class="item text-right">
                      <button
                        type="button"
                        class="btn btn-outline-primary btn-sm"
                        @click="
                          $common.downloadResumePDF(
                            resumeDetail.ResumeType,
                            resumeDetail.ResumeId
                          )
                        "
                      >
                        下載 PDF
                      </button>
                    </div>
                  </div>
                  <IdlResume
                    v-if="resumeDetail.ResumeType === 'IDL'"
                    :ResumeId="resumeDetail.ResumeId"
                    :ResumeType="'IDL'"
                  />
                  <DlResume
                    v-if="resumeDetail.ResumeType === 'DL'"
                    :ResumeId="resumeDetail.ResumeId"
                    :ResumeType="'DL'"
                  />
                </section>
              </perfect-scrollbar>
            </transition>
          </div>
        </div>
      </div>
    </transition>

    <el-dialog title="QrCode" :visible.sync="qrCodeDialogVisible" width="400px">
      <div class="text-center">
        <qrcode-vue :value="QRCode" size="350" />
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="qrCodeDialogVisible = false">關閉</el-button>
      </span>
    </el-dialog>

    <!-- 匯入資料 API 回應訊息 -->
    <ResponseDataModal
      :successfulList="successMessage"
      :failedList="failMessage"
    />

    <!-- 預覽 Modal -->
    <PreviewMailModal :type="'interview'" :mail="previewData" />
  </div>
</template>

<script>
/* global $ */
import { mapGetters, mapActions } from "vuex";
import PreviewMailModal from "@/components/back/Modal/PreviewMailModal.vue";
import QrcodeVue from "qrcode.vue";
import moment from "moment";

// 履歷(DL/IDL)
import IdlResume from "@/components/customize/Back/IdlResume";
import DlResume from "@/components/customize/Back/DlResume";

// API 回應訊息
import ResponseDataModal from "@/components/back/Modal/ResponseData";

export default {
  name: "RoomScheduleSetting",

  components: {
    QrcodeVue,
    IdlResume,
    DlResume,
    ResponseDataModal,
    PreviewMailModal,
  },
  data() {
    return {
      scan: false,
      qrCodeDialogVisible: false,
      reloadTime: null, //重新刷新的時間

      // 卡片顯示樣式
      gridStyle: "block",
      QRCode: "",
      currentPerson: {},
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now();
        },
      },
      reArrangeDatePickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        },
      },
      openingList: [],
      // 轉入職缺
      transformModal: {},

      resumeDetail: {},
      isShowDetail: false,

      choosePersonList: [],
      activeName: "first",
      search: {
        InvitationTime: [this.$common.getToday(), this.$common.getToday()],
        TimePeriod: null,
      },
      flowOptions: [],
      contactOptions: [],
      timePeriodOptions: [],

      personList: [],

      //新增臨時到廠
      temporaryForm: {},

      // 匯入資料-回應訊息
      successMessage: [], // 成功訊息
      failMessage: [], // 失敗訊息

      //改期罐頭訊息
      reArrangeOptions: [],
      //取消罐頭訊息
      cancelOptions: [],

      // 範本
      mailParameters: {},
      mailTemplates: [],

      // 所選擇範本的 guid
      selectedTemplateGuid: null,

      // 信件內容
      mail: {},
      // 預覽內容
      previewData: {},

      // 面談主管選項
      supervisorOptions: [],
      // 面談地點選項
      interviewPlaceOptions: [],

      // 附件
      fileGroupGuid: "",
      resetFileStatus: true, // 第一次必為 true
      uploadFileList: [], // 上傳附件列表
    };
  },

  watch: {
    showInterviewMail: function (e) {
      if (e) {
        this.selectedTemplateGuid = null;
        this.mail = {
          Email: this.personData.Email,
          Interviewee: this.personData.Name,
          Position: this.personData.Position,
          MatchId: this.personData.MatchId,
        };
        this.sendMail = true;
        this.fileGroupGuid = "";
        this.resetFileStatus = true;
        this.uploadFileList = [];
        this.$refs.letter.reset();
        $("#interviewMailModal").modal("show");
      } else {
        $("#interviewMailModal").modal("hide");
      }
    },
  },

  methods: {
    changeTab() {
      const vm = this;
      if (vm.activeName === "third") {
        vm.search.InvitationTime = [];
      } else {
        let day = new Date();
        vm.search.InvitationTime = [day, day];
      }

      vm.getCheckIn();
    },
    getCheckIn() {
      const vm = this;

      let params = {
        ...vm.search,
        InvitationTime:
          vm.search.InvitationTime === null
            ? [vm.dayjs().add(1, "day").format("YYYY-MM-DD"), "9999-01-01"]
            : vm.search.InvitationTime,
        CheckInType: vm.activeName === "second" ? 2 : 1,
      };

      vm.$store.dispatch("updateLoading", true);

      vm.$api.InterviewSch.getCheckIn(params)
        .then((response) => {
          if (response.data.ErrorMessage) {
            this.$notify({
              message: response.data.ErrorMessage,
              type: "error",
            });
          } else {
            vm.personList = response.data.Data;
          }

          vm.$store.dispatch("updateLoading", false);
        })
        .catch((error) => {
          vm.$store.dispatch("updateLoading", false);
          this.$notify({
            title: "錯誤",
            message: error.response.data.ErrorMessage,
            type: "error",
          });
        });
    },

    checkIn(person) {
      const vm = this;
      vm.$store.dispatch("updateLoading", true);
      vm.$api.InterviewSch.checkInArrange(person.ArrangeGuid)
        .then((response) => {
          if (response.data.ErrorMessage) {
            this.$notify({
              message: response.data.ErrorMessage,
              type: "error",
            });
          } else {
            vm.getCheckIn();
            this.$notify({
              message: response.data.Data,
              type: "success",
            });
          }
          vm.$store.dispatch("updateLoading", false);
        })
        .catch((error) => {
          vm.$store.dispatch("updateLoading", false);
          this.$notify({
            title: "錯誤",
            message: error.response.data.ErrorMessage,
            type: "error",
          });
        });
    },

    saveFlow(val, guid) {
      const vm = this;
      vm.$store.dispatch("updateLoading", true);
      let params = {
        arrangeGuid: guid,
        baseFlowGuid: val,
      };
      vm.$api.InterviewSch.setFlow(params)
        .then((response) => {
          if (response.data.ErrorMessage) {
            this.$notify({
              message: response.data.ErrorMessage,
              type: "error",
            });
          } else {
            this.$notify({
              message: response.data.Data,
              type: "success",
            });
          }
          vm.$store.dispatch("updateLoading", false);
        })
        .catch((error) => {
          vm.$store.dispatch("updateLoading", false);
          this.$notify({
            title: "錯誤",
            message: error.response.data.ErrorMessage,
            type: "error",
          });
        });
    },

    saveContact(val, guid) {
      const vm = this;
      vm.$store.dispatch("updateLoading", true);
      let params = {
        arrangeGuid: guid,
        contactPersonGuid: val,
      };
      vm.$api.InterviewSch.setContact(params)
        .then((response) => {
          if (response.data.ErrorMessage) {
            this.$notify({
              message: response.data.ErrorMessage,
              type: "error",
            });
          } else {
            this.$notify({
              message: response.data.Data,
              type: "success",
            });
          }
          vm.$store.dispatch("updateLoading", false);
        })
        .catch((error) => {
          vm.$store.dispatch("updateLoading", false);
          this.$notify({
            title: "錯誤",
            message: error.response.data.ErrorMessage,
            type: "error",
          });
        });
    },

    setHrSupervisor(val, guid) {
      const vm = this;
      vm.$store.dispatch("updateLoading", true);
      let params = {
        arrangeGuid: guid,
        contactPersonGuid: val,
      };
      vm.$api.InterviewSch.setHrSupervisor(params)
        .then((response) => {
          if (response.data.ErrorMessage) {
            this.$notify({
              message: response.data.ErrorMessage,
              type: "error",
            });
          } else {
            this.$notify({
              message: response.data.Data,
              type: "success",
            });
          }
          vm.$store.dispatch("updateLoading", false);
        })
        .catch((error) => {
          vm.$store.dispatch("updateLoading", false);
          this.$notify({
            title: "錯誤",
            message: error.response.data.ErrorMessage,
            type: "error",
          });
        });
    },
    setManagerSupervisor(val, guid) {
      const vm = this;
      vm.$store.dispatch("updateLoading", true);
      let params = {
        arrangeGuid: guid,
        contactPersonGuid: val,
      };
      vm.$api.InterviewSch.setManagerSupervisor(params)
        .then((response) => {
          if (response.data.ErrorMessage) {
            this.$notify({
              message: response.data.ErrorMessage,
              type: "error",
            });
          } else {
            this.$notify({
              message: response.data.Data,
              type: "success",
            });
          }
          vm.$store.dispatch("updateLoading", false);
        })
        .catch((error) => {
          vm.$store.dispatch("updateLoading", false);
          this.$notify({
            title: "錯誤",
            message: error.response.data.ErrorMessage,
            type: "error",
          });
        });
    },

    reArrange() {
      const vm = this;
      vm.$store.dispatch("updateLoading", true);
      let params = {
        ...vm.currentPerson,
        ReArrangeReason: vm.currentPerson.ReArrangeReason,
        ReArrangeDate:
          vm.currentPerson.ReArrangeDate + " " + vm.currentPerson.ReArrangeTime,

        FileGroupId: this.fileGroupGuid ? this.fileGroupGuid : null,
        InterviewSupervisor: vm.currentPerson.InterviewSupervisor
          ? [vm.currentPerson.InterviewSupervisor]
          : null,
        InterviewHR: vm.currentPerson.InterviewHR
          ? [vm.currentPerson.InterviewHR]
          : null,
      };
      vm.$api.InterviewSch.reArrange(vm.currentPerson.ArrangeGuid, params)
        .then((response) => {
          if (response.data.ErrorMessage) {
            this.$notify({
              message: response.data.ErrorMessage,
              type: "error",
            });
          } else {
            vm.getCheckIn();
            $("#interviewMailModal").modal("hide");
            this.$notify({
              message: response.data.Data,
              type: "success",
            });
          }
          vm.$store.dispatch("updateLoading", false);
        })
        .catch((error) => {
          vm.$store.dispatch("updateLoading", false);
          this.$notify({
            title: "錯誤",
            message: error.response.data.ErrorMessage,
            type: "error",
          });
        });
    },
    cancelInterview() {
      const vm = this;
      vm.$store.dispatch("updateLoading", true);
      let params = {
        CancelGuid: vm.currentPerson.CancelGuid,
        CancelSecondGuid: vm.currentPerson.CancelSecondGuid,
        CancelReason: vm.currentPerson.CancelReason,
      };
      vm.$api.InterviewSch.cancelInterview(vm.currentPerson.ArrangeGuid, params)
        .then((response) => {
          if (response.data.ErrorMessage) {
            this.$notify({
              message: response.data.ErrorMessage,
              type: "error",
            });
          } else {
            vm.getCheckIn();
            $("#cancelModal").modal("hide");
            this.$notify({
              message: response.data.Data,
              type: "success",
            });
          }
          vm.$store.dispatch("updateLoading", false);
        })
        .catch((error) => {
          vm.$store.dispatch("updateLoading", false);
          this.$notify({
            title: "錯誤",
            message: error.response.data.ErrorMessage,
            type: "error",
          });
        });
    },

    // 改期時，選擇第二層項目時要順便傳第一層項目
    findParentGuid(e) {
      const vm = this;
      let parent = vm.cancelOptions.find((item) => {
        return item.Children.find((childItem) => {
          return childItem.Guid === e;
        });
      });

      vm.currentPerson.CancelGuid = parent.Guid;
    },

    // 檢視履歷
    showDetailModal(person) {
      const vm = this;
      vm.resumeDetail = {
        ArrangeGuid: person.ArrangeGuid,
        ResumeType: person.ArrangeGuid === null ? "IDL" : person.ResumeType,
        ResumeId: person.ResumeId,
      };

      this.isShowDetail = true;
    },
    openScanModal() {
      this.scan = false;
      $("#scanModal").modal("show");
    },
    //重新讀取
    reload() {
      const today = new Date();
      const hour = today.getHours();
      const min = today.getMinutes();
      const sec = today.getSeconds();

      // 轉成字串，如果低於10，前面加上'0'
      const hourString = hour < 10 ? "0" + hour : "" + hour;
      const minString = min < 10 ? "0" + min : "" + min;
      const secString = sec < 10 ? "0" + sec : "" + sec;

      this.reloadTime = hourString + ":" + minString + ":" + secString;

      this.getCheckIn();
    },
    //打開新增臨時到廠
    openTemporaryModal() {
      const vm = this;
      vm.temporaryForm = {};
      vm.$refs["temporaryForm"].clearValidate();
      $("#temporaryModal").modal("show");
    },

    //新增臨時到廠
    addArrangeTemporary() {
      const vm = this;

      this.$refs["temporaryForm"].validate((valid) => {
        if (valid) {
          vm.$store.dispatch("updateLoading", true);
          vm.$api.InterviewSch.addArrangeTemporary(vm.temporaryForm)
            .then((response) => {
              if (response.data.ErrorMessage) {
                this.$notify({
                  message: response.data.ErrorMessage,
                  type: "error",
                });
              } else {
                vm.getCheckIn();
                $("#temporaryModal").modal("hide");
                this.$notify({
                  message: response.data.Data,
                  type: "success",
                });
              }
              vm.$store.dispatch("updateLoading", false);
            })
            .catch((error) => {
              vm.$store.dispatch("updateLoading", false);
              this.$notify({
                title: "錯誤",
                message: error.response.data.ErrorMessage,
                type: "error",
              });
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    //批次轉入職缺
    matchJobManagement() {
      const vm = this;
      vm.$store.dispatch("updateLoading", true);
      let params = {
        ...vm.transformModal,
        ArrangeTempGuids: vm.choosePersonList,
      };
      vm.$api.InterviewSch.matchJobManagement(params)
        .then((response) => {
          if (response.data.ErrorMessage) {
            this.$notify({
              message: response.data.ErrorMessage,
              type: "error",
            });
          } else {
            vm.getCheckIn();
            vm.transformModal = {};
            vm.choosePersonList = [];
            $("#matchJobModal").modal("hide");

            vm.successMessage = response.data.Data.filter((item) => {
              return item.indexOf("成功") !== -1;
            });
            vm.failMessage = response.data.Data.filter((item) => {
              return item.indexOf("失敗") !== -1;
            });
            vm.$store.commit("OpenResponseDataModal", true);
          }
          vm.$store.dispatch("updateLoading", false);
        })
        .catch((error) => {
          vm.$store.dispatch("updateLoading", false);
          this.$notify({
            title: "錯誤",
            message: error.response.data.ErrorMessage,
            type: "error",
          });
        });
    },

    showScanTwo() {
      $("#scanModal").modal("hide");
      $("#scanTwoModal").modal("show");
    },
    // 多國語系
    i18n(keyStr) {
      return this.$t(keyStr);
    },

    // Action Modal
    openMatchJobModal() {
      $("#matchJobModal").modal("show");
    },
    clearSelect() {
      this.choosePersonList = [];
    },

    openArrivalModal(row) {
      this.currentPerson = { ...row };
      $("#arrivalModal").modal("show");
    },

    openCancelModal(row) {
      this.currentPerson = { ...row };
      $("#cancelModal").modal("show");
    },

    async openReArrangeModal(row) {
      this.currentPerson = {
        ...row,
        ReArrangeDate: null,
      };
      this.selectedTemplateGuid = null;
      this.uploadFileList = [];
      this.$refs.currentPersonForm.reset();
      $("#interviewMailModal").modal("show");
    },

    // 上傳 附件
    uploadFile(file) {
      this.updateLoading(true);

      let fd = new FormData();
      fd.append("File", file.raw);
      fd.append("FileType", file.raw.type);
      fd.append("FileGroupGuid", this.fileGroupGuid);
      fd.append("CreateUser", null);

      this.$api.file.uploadFile(fd).then((response) => {
        if (response.status === 200) {
          this.updateLoading(false);
          this.fileGroupGuid = response.data;
          this.resetFileStatus = false;
          this.getFileList(this.fileGroupGuid);
        }
      });
    },

    // 取得 附件
    getFileList(fileGroupGuid) {
      this.updateLoading(true);
      const params = {
        resetFileStatus: this.resetFileStatus,
      };
      this.$api.file.getFileDetails(params, fileGroupGuid).then((response) => {
        if (response.status === 200) {
          this.uploadFileList = response.data.filter((item) => !item.IsDelete);
        }
        this.updateLoading(false);
      });
    },

    // 刪除 附件
    removeFile({ fileGuid, fileGroupGuid }) {
      this.updateLoading(true);
      this.$api.file.removeFile(fileGuid).then((response) => {
        if (response.status === 200) {
          this.$notify({
            title: "成功",
            message: "刪除成功",
            type: "success",
            duration: 2500,
          });
          this.uploadFileList = [];
          this.resetFileStatus = false;
          this.getFileList(fileGroupGuid);
        }
        this.updateLoading(false);
      });
    },

    // 依guid 取得信件範本內容
    getMailTemplateDetail() {
      this.updateLoading(true);
      this.$api.mailTemplate
        .getMailTemplateDetail(this.selectedTemplateGuid)
        .then((response) => {
          if (response.status === 200) {
            this.$set(
              this.currentPerson,
              "MailSubject",
              response.data.MailTemplateSubject
            );
            this.$set(
              this.currentPerson,
              "MailTemplateBody",
              response.data.MailTemplateBody
            );
          }
          this.updateLoading(false);
        });
    },

    // 預覽
    preview() {
      this.previewData = {
        ...this.currentPerson,
        InterviewSupervisor: this.currentPerson.InterviewSupervisor
          ? [this.currentPerson.InterviewSupervisor]
          : null,
        InterviewHR: [this.currentPerson.InterviewHR],
        Interviewee: this.currentPerson.Name,
        InterviewTime: this.currentPerson.ReArrangeTime,
      };
      this.$store.commit("OpenPreviewMailModal", true);
    },

    async getData() {
      const vm = this;
      vm.updateLoading(true);
      const [
        personList,
        openingList,
        reArrangeOptions,
        cancelOptions,
        QRCode,
        flowOptions,
        timePeriodOptions,
        contactOptions,
        backgroundUser,
        parameter,
        template,
        place,
      ] = await this.$http.all([
        vm.$api.InterviewSch.getCheckIn({
          ...vm.search,
          InvitationTime:
            vm.search.InvitationTime === null
              ? [vm.dayjs().add(1, "day").format("YYYY-MM-DD"), "9999-01-01"]
              : vm.search.InvitationTime,
          CheckInType: vm.activeName === "second" ? 2 : 1,
        }),
        vm.$api.opening.getOpening(),
        vm.$api.InterviewSch.getReArrangeOptions(),
        vm.$api.InterviewSch.getCancelOptions(),
        vm.$api.InterviewSch.getExternalUrl(),
        vm.$api.InterviewSch.getFlowOptions(),
        vm.$api.InterviewSch.getTimePeriodOptions(),
        vm.$api.InterviewSch.getContactOptions(),
        vm.$api.backgroundUser.getBackgroundUser(),
        vm.$api.mailTemplate.getMailParameter(
          "E6BA3540-BA9B-487A-BF90-F6D115C763AD"
        ),
        this.$api.mailTemplate.getMailTemplatePaging(
          { isPaging: false },
          "InterviewInvitation"
        ),
        this.$api.interviewPlace.getInterviewPlacePaging({ isPaging: false }),
      ]);

      vm.personList = personList.data.Data;
      vm.openingList = openingList.data.map((item) => ({
        ManpowerDemandNo: item.ManpowerDemandNo,
        ManpowerDemandName: item.ManpowerDemandName,
      }));
      vm.reArrangeOptions = reArrangeOptions.data.Data;
      vm.cancelOptions = cancelOptions.data.Data;
      vm.QRCode = QRCode.data;
      vm.flowOptions = flowOptions.data.Data;
      vm.timePeriodOptions = timePeriodOptions.data.Data;
      vm.contactOptions = contactOptions.data.Data;
      // 取得 主管選項
      this.supervisorOptions = backgroundUser.data.map((user) => ({
        Guid: user.UserId,
        Name: user.Name,
        Email: user.Email,
      }));
      // 取得 信件參數
      this.mailParameters = parameter.data;
      // 取得 信件範本
      this.mailTemplates = template.data.Datas;
      // 取得 面談地點
      this.interviewPlaceOptions = place.data.Data;

      vm.updateLoading(false);
    },

    // loading
    ...mapActions(["updateLoading"]),
  },

  computed: {
    ...mapGetters(["lang"]),
    isLoading() {
      return this.$store.state.isLoading;
    },
  },

  filters: {
    moment: function (date) {
      if (date === null) {
        return null;
      } else {
        return moment(date).format("YYYY-MM-DD");
      }
    },
    momentTime: function (date) {
      if (date === null) {
        return null;
      } else {
        return moment(date).format("HH:mm");
      }
    },
    momentDateTime: function (date) {
      if (date === null) {
        return null;
      } else {
        return moment(date).format("YYYY-MM-DD HH:mm");
      }
    },
  },

  created() {
    this.getData();
  },

  destroyed() {
    $(".modal").modal("hide");
    $("body").removeClass("modal-open");
    $(".modal-backdrop").remove();
  },
};
</script>

<style lang="scss" scoped>
.p-card {
  background-color: #fff;
  overflow: hidden;
  border-radius: 6px;
  border: 5px solid #ccc;

  margin: 10px;
  .person-info {
    display: flex;
    padding: 10px;
    position: relative;
    z-index: 2;
    align-items: center;
    img {
      width: 100px;
      height: 100px;
      object-fit: cover;
      border-radius: 10px;
      box-shadow: 5px 5px 0 rgba(#000, 0.15);
      margin-right: 15px;
    }
    .info {
      flex: 1;
      .name {
        font-size: 1.1em;
        font-weight: bold;
        margin-bottom: 5px;
        padding: 0 15px;
        background-color: #f8f2a0;
        display: inline-block;
        border-radius: 25px;
        cursor: pointer;

        &.female {
          background-color: #ffd4d4;
        }

        &.male {
          background-color: #d9e3ff;
        }
      }
      .id {
        font-size: 0.8em;
        display: inline-block;
        margin-left: 5px;
      }
      .job {
        padding: 3px 10px;
        font-size: 0.8em;
        margin-top: 5px;
        display: block;

        text-overflow: ellipsis;
        overflow: hidden;
        width: 200px;
        white-space: nowrap;
      }
      .resume-btn {
        margin-left: 5px;
        background-color: #5380f7;
        color: #fff;
        padding: 3px 15px;
        font-size: 0.8em;
        margin-top: 17px;
        border-radius: 25px;
        border: none;
      }
      .check-label {
        transform: scale(1.8);
        margin-top: 10px;
        margin-left: 10px;
        position: absolute;
        right: 15px;
        top: 0;

        input {
          cursor: pointer;
        }
      }
    }
  }
  .job-info {
    background-color: #fff;
    padding: 20px;
    position: relative;
    &::after {
      content: "";
      width: 200%;
      height: 100px;
      position: absolute;
      z-index: 1;
      top: 0;
      left: 0;
      background-color: #fff;
      transform: rotate(-7deg);
      transform-origin: top left;
    }
    span {
      background-color: #fff;
      border: 1px solid #e7e7e7;
      border-radius: 25px;
      padding: 3px 5px;
      overflow: hidden;
      display: flex;
      align-items: center;
      .svg-wrap {
        background-color: #5380f7;
        margin-right: 5px;
        border-radius: 50%;
        width: 35px;
        height: 30px;
        text-align: center;
        color: #fff;
        line-height: 30px;
        svg {
          width: 15px;

          fill: #fff;
          position: relative;
          top: -2px;
        }
      }

      .el-select {
        flex: 1;
      }

      position: relative;
      z-index: 2;
      /deep/ .el-input__inner {
        border: none !important;
      }

      .info-time {
        line-height: 40px;
        margin-left: 10px;
      }
    }
    .button-wrap {
      margin-top: 10px;
      min-height: 30px;
    }
  }

  //如果沒有報到時間
  &.darken {
    .job-info {
      background-color: #ccced3;
      &::after {
        background-color: #ccced3;
      }
    }
  }

  &.gray-card {
    background-color: #e4e4e4;
  }
}

.card-list {
  .p-card {
    display: inline-block;
  }

  //如果是列表樣式
  &.list-style {
    .p-card {
      display: flex;
      .person-info {
        img {
          width: 80px;
          height: 80px;
        }
      }
      .job-info {
        flex: 1;
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        label {
          display: inline-flex;
          margin-right: 10px;
          margin-bottom: 0;
        }
      }
    }
  }
}

/deep/ #ReArrangeTime * {
  border: none !important;
  box-shadow: none !important;
  .mx-icon-calendar {
    display: none;
  }

  ::placeholder {
    /* Chrome, Firefox, Opera, Safari 10.1+ */
    color: #bac0c5;
    opacity: 1; /* Firefox */
  }
}

#interviewMailModal {
  .modal-dialog {
    max-width: 960px;
    .modal-content {
      background-color: transparent;
      border: none;
    }
  }
}
</style>
